module.exports = __webpack_public_path__ + "static/media/galeryVinyl5.aa723c5d.jpg";